export function initSupplierOnboardingSetPassword () {
  function run () {
    const body = document.body

    if (
      !body.classList.contains('supplier_onboardings-controller') ||
      !body.classList.contains('business_info-action')
    ) {
      return
    }

    const modal = document.getElementById('set-password')
    if (!modal) return

    const isVerified = modal.dataset.isVerified === 'true'
    if (isVerified) return

    if (window.Foundation && window.Foundation.Reveal) {
      const reveal = new window.Foundation.Reveal(modal)
      reveal.open()
      return
    }

    modal.style.display = 'block'
    modal.removeAttribute('aria-hidden')
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run)
  } else {
    run()
  }
}
